module.exports = __webpack_public_path__ + "img/niedersachsen.b701740.webp";